import React from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon, AwardIcon, BookOpenIcon, ChevronRightIcon, GraduationCapIcon, BuildingIcon } from 'lucide-react';
import { universities } from '../data/universities';
export function CollegesPage() {
  return <main className="flex-grow bg-light" data-id="element-360">
      {/* Hero */}
      <div className="bg-navy text-white py-16" data-id="element-361">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-362">
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-white/10 border border-white/15 text-gold text-sm font-semibold mb-5" data-id="element-363">
            <BuildingIcon className="w-4 h-4 mr-2" data-id="element-364" />
            Partner Schools
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight mb-4" data-id="element-365">
            Explore Our Partner Colleges
          </h1>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-366">
            Browse accredited colleges and universities with dedicated program
            pages. Select a school to explore their offerings.
          </p>
        </div>
      </div>

      {/* Listings */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-367">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-368">
          {universities.map(uni => <Link key={uni.slug} to={`/colleges/${uni.slug}`} className="group bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden hover:shadow-md hover:border-navy/30 transition-all duration-200 flex flex-col" data-id="element-369">
              {/* Card Header with Gradient */}
              <div className="bg-gradient-to-r from-navy via-navy-dark to-crimson p-6 flex items-center gap-4" data-id="element-370">
                <div className="w-14 h-14 rounded-full bg-white/15 border-2 border-white/25 flex items-center justify-center flex-shrink-0" data-id="element-371">
                  <GraduationCapIcon className="w-7 h-7 text-white" data-id="element-372" />
                </div>
                <div data-id="element-373">
                  <h2 className="text-lg font-bold text-white leading-tight" data-id="element-374">
                    {uni.name}
                  </h2>
                  <div className="flex items-center text-gray-300 text-sm mt-1" data-id="element-375">
                    <MapPinIcon className="w-3.5 h-3.5 mr-1" data-id="element-376" />
                    {uni.location}
                  </div>
                </div>
              </div>

              {/* Card Body */}
              <div className="p-6 flex flex-col flex-grow" data-id="element-377">
                <p className="text-sm text-gray-600 mb-4 line-clamp-3" data-id="element-378">
                  {uni.description}
                </p>

                <div className="flex items-start text-xs text-gray-500 mb-4" data-id="element-379">
                  <AwardIcon className="w-4 h-4 mr-2 text-gold flex-shrink-0 mt-0.5" data-id="element-380" />
                  <span data-id="element-381">{uni.accreditation}</span>
                </div>

                {/* Programs Preview */}
                <div className="mt-auto pt-4 border-t border-gray-100" data-id="element-382">
                  <div className="flex items-center text-xs font-bold text-gray-500 uppercase tracking-wider mb-3" data-id="element-383">
                    <BookOpenIcon className="w-3.5 h-3.5 mr-1.5" data-id="element-384" />
                    {uni.programs.length} Programs Available
                  </div>
                  <div className="flex flex-wrap gap-2" data-id="element-385">
                    {uni.programs.slice(0, 3).map(prog => <span key={prog.slug} className="text-xs bg-gray-100 text-gray-700 px-2 py-1 rounded" data-id="element-386">
                        {prog.shortTitle}
                      </span>)}
                    {uni.programs.length > 3 && <span className="text-xs text-gray-400 px-2 py-1" data-id="element-387">
                        +{uni.programs.length - 3} more
                      </span>}
                  </div>
                </div>

                <div className="flex items-center text-sm font-semibold text-navy mt-4 group-hover:text-crimson transition-colors duration-200" data-id="element-388">
                  View Programs
                  <ChevronRightIcon className="w-4 h-4 ml-1 transform group-hover:translate-x-1 transition-transform duration-200" data-id="element-389" />
                </div>
              </div>
            </Link>)}
        </div>

        {/* Empty State (for when more colleges are added) */}
        {universities.length === 0 && <div className="text-center py-16" data-id="element-390">
            <BuildingIcon className="w-12 h-12 text-gray-300 mx-auto mb-4" data-id="element-391" />
            <h3 className="text-xl font-bold text-navy mb-2" data-id="element-392">
              No colleges listed yet
            </h3>
            <p className="text-gray-500" data-id="element-393">
              Check back soon — we're adding new partner schools.
            </p>
          </div>}
      </div>
    </main>;
}